module.exports = __webpack_public_path__ + "img/ac-logo-dark.245f58a1.png";